module.exports = __webpack_public_path__ + "static/home-92c2d08ba7c6b7636338236cee6b0d56.mp4";